import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import { GlobalProvider } from "./context/GlobalContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Dashboard from "./pages/Dashboard";
import Productos from "./pages/Productos";
import Proveedores from "./pages/Proveedores";
import Categorias from "./pages/Categorias";
import GestionOperaciones from "./pages/GestionOperaciones";
import Ubicaciones from "./pages/Ubicaciones";
import MapaBodega from "./pages/MapaBodega";
import RecepcionMercancia from "./pages/RecepcionMercancia";
import HistorialFacturas from "./pages/HistorialFacturas";
import Login from './pages/Login';
import Users from './pages/Users';
import ProductDetailPage from './pages/ProductDetailPage';
import ProductFormPage from './pages/ProductFormPage';
import POS from './pages/POS';
import ConteoCiego from './pages/ConteoCiego';
// Force reload to fix HMR ReferenceError
import ProtectedRoute, { AdminRoute, ManagerRoute } from './components/ProtectedRoute';
import Layout from './components/Layout';

import "./styles/styles.css";
import './styles/SearchBar.css';
import './styles/Button.css';
import './styles/Modal.css';
import './styles/ItemForm.css';
import './styles/Categorytree.css';
import './styles/DeleteWarning.css';


const App: React.FC = () => {
  return (
    <AuthProvider>
      <GlobalProvider>
        <Router>
          <div className="app-container">
            <Navbar />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                {/* Dashboard - Acceso para todos los usuarios autenticados */}
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />

                {/* Productos - Managers y Admins */}
                <Route path="productos" element={
                  <ManagerRoute>
                    <Productos />
                  </ManagerRoute>
                } />
                <Route path="productos/:id" element={
                  <ManagerRoute>
                    <ProductDetailPage />
                  </ManagerRoute>
                } />
                <Route path="productos/editar/:id" element={
                  <ManagerRoute>
                    <ProductFormPage />
                  </ManagerRoute>
                } />

                <Route path="proveedores" element={
                  <ManagerRoute>
                    <Proveedores />
                  </ManagerRoute>
                } />
                <Route path="categorias" element={
                  <ManagerRoute>
                    <Categorias />
                  </ManagerRoute>
                } />
                <Route path="operaciones" element={
                  <ManagerRoute>
                    <GestionOperaciones />
                  </ManagerRoute>
                } />
                <Route path="recepcion" element={
                  <ManagerRoute>
                    <RecepcionMercancia />
                  </ManagerRoute>
                } />
                <Route path="recepcion/historial" element={
                  <ManagerRoute>
                    <HistorialFacturas />
                  </ManagerRoute>
                } />
                <Route path="ubicaciones" element={
                  <ManagerRoute>
                    <Ubicaciones />
                  </ManagerRoute>
                } />
                <Route path="mapa-bodega" element={
                  <ManagerRoute>
                    <MapaBodega />
                  </ManagerRoute>
                } />
                <Route path="conteo-ciego" element={
                  <ManagerRoute>
                    <ConteoCiego />
                  </ManagerRoute>
                } />

                {/* Usuarios - Solo Admins */}
                <Route path="users" element={
                  <AdminRoute>
                    <Users />
                  </AdminRoute>
                } />

                {/* POS - Empleados y superiores */}
                <Route path="pos" element={
                  <ProtectedRoute>
                    <POS />
                  </ProtectedRoute>
                } />
              </Route>
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </GlobalProvider>
    </AuthProvider>
  );
};

export default App;